import { FeatureFlag } from '../FeatureFlag';

export const disableSessionBarrier = new FeatureFlag({
    key: 'disable-session-barrier',
    defaultValue: false,
});
